import { motion } from "@inkhunt/core";

// Page entry: content rises 12px and fades in once, on the shared ease-out curve. It used to
// wait half a second before starting, which read as lag rather than polish.
export const transitionProps = {
  variants: {
    initial: {
      opacity: 0,
      y: 12,
    },
    final: {
      opacity: 1,
      y: 0,
      transition: {
        duration: motion.duration.slow / 1000,
        ease: motion.easeOut,
      },
    },
  },
  initial: "initial",
  animate: "final",
};

// Dialogs and overlays fade only: a fixed full-screen layer should not slide.
export const fadeProps = {
  variants: {
    initial: { opacity: 0 },
    final: {
      opacity: 1,
      transition: { duration: motion.duration.base / 1000, ease: motion.easeOut },
    },
  },
  initial: "initial",
  animate: "final",
};
